import { injectCpmsBoTransactionApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTransactionApi = injectCpmsBoTransactionApi(baseApi);

export const {
  useCpmsBoGetTransactionQuery,
  useCpmsBoGetTransactionsPaginatedQuery,
  useLazyCpmsBoGetTransactionsCsvQuery,
} = cpmsBoTransactionApi;
